import React, { useState, useEffect } from 'react';
import { Card, Box, Typography, Stack } from '@curves/ui-base';
import { getAddMonths, getNowTime, getSubMonths, parseDate } from "@Util/moment";
import { WorkoutCalendarBox } from "@Local/Member/Components";
import useMemberWorkoutApi from '@Apis/useMemberWorkoutApi';
import { MemberUserBox } from '@Local/Member/Components';
import { localUser } from "@Util/utils";
import { useMainLayoutContext } from "@Local/Components/Layout/Context/MainLaydoutContext";
import { FOOTER_TYPE, HEADER_TYPE, THEME_TYPE } from "@Constants/dataEnums";


const MemberWorkoutPage = () => {
    const user = localUser.get();
    const { displayName } = user || {};
    const [currentDate, setCurrentDate] = useState(getNowTime());
    const [summaryData, setSummaryData] = useState({});
    const [calendarData, setCalendarData] = useState({});
    const { getMemberWorkoutSummaryApi, getMemberWorkoutCalendarApi } = useMemberWorkoutApi();

    const { setHeaderType, setFooterType, setThemeType } = useMainLayoutContext();

    const {
        totalWorkoutQuantity = 0,
        monthlyWorkoutQuantity = 0
    } = summaryData;

    const doSummaryApi = async () => {
        const resp = await getMemberWorkoutSummaryApi();
        if (resp) {
            setSummaryData(resp);
        }
    };

    const doCalendarApi = async () => {
        const params = {
            calTime: parseDate(currentDate, 'YYYYMM'),
        }
        const resp = await getMemberWorkoutCalendarApi(params);
        if (resp) {
            setCalendarData(resp);
        }
    };

    const handlePrev = (calendarToShow) => {
        let calTime = getSubMonths(currentDate, calendarToShow);
        setCurrentDate(calTime);
    };

    const handleNext = (calendarToShow) => {
        let calTime = getAddMonths(currentDate, calendarToShow);
        setCurrentDate(calTime);
    };

    useEffect(() => {
            doSummaryApi();
            doCalendarApi();
        },
        // eslint-disable-next-line
        [currentDate]
    );

    useEffect(() => {
            setHeaderType(HEADER_TYPE.HIDE_USER | HEADER_TYPE.LOGO_CENTER | HEADER_TYPE.HIDE_BACKGROUND | HEADER_TYPE.LOGO_WHITE);
            setFooterType(FOOTER_TYPE.HIDE_BORDER_TOP | FOOTER_TYPE.FLEX);
            setThemeType(THEME_TYPE.DARK);
        },
        // eslint-disable-next-line
        []
    );

    return (
        <Box className={'container'}>
            <MemberUserBox displayName={displayName} />
            <Stack className={'workout-amount-section'} alignItems={'center'} justifyContent={'center'} spacing={2}>
                <Card className={'workout-amount-box'}>
                    <Typography variant={'subtitle1'}>總次數</Typography>
                    <Typography variant={'body1'}>{totalWorkoutQuantity}</Typography>
                </Card>
                <Card className={'workout-amount-box'}>
                    <Typography variant={'subtitle1'}>本月次數</Typography>
                    <Typography variant={'body1'}>{monthlyWorkoutQuantity}</Typography>
                </Card>
            </Stack>
            <Stack className={'workout-calendar-section'} direction={'row'} justifyContent={'center'}>

                <Card>
                    <WorkoutCalendarBox
                        currentDate={currentDate}
                        handlePrev={handlePrev}
                        handleNext={handleNext}
                        sourceData={calendarData}
                    />
                    <Box className={'workout-calendar-tip'}>
                        <span className={'workout-calendar-tip-today'}>當日</span>
                        <span className={'workout-calendar-tip-workout'}>運動日</span>
                        <span className={'workout-calendar-tip-measure'}>量身日</span>
                    </Box>
                </Card>


            </Stack>

        </Box>
    )
}

export default MemberWorkoutPage;